
export function call(method: string, param: object, property?: string): Promise<any> {
    var promise = new Promise(function (resolve, reject) {
        window.tutor.call(method, param, function (e, res) {
            if (e) {
                reject({ error: e, apiCall: method });
            } else if (res && res.error) {
                reject({ ...res, apiCall: method });
            } else {
                resolve(property ? res[property] : res);
            }
        });
    });

    return promise;
}


export function projectCall(method: string, param: object, property?: string) {
    var promise = new Promise(function (resolve, reject) {
        window.tutorProject.call(method, param, function (e, res) {
            if (e) {
                reject({ error: e, apiCall: method });
            } else if (res && res.error) {
                reject({ ...res, apiCall: method });
            } else {
                resolve(property ? res[property] : res);
            }
        });
    });

    return promise;
}